import React, { useState, useContext, useEffect } from "react";
import Head from "../Head/Head";
import Squares from "../Squares/Squares";
import Text from "../Text/Text";
import Elements from "../Elements/Elements";
import "./StepFive.scss";

import { SquareContext } from "../../SquareContext";
import { ShapeContext } from "../../ShapeContext";
import { useMediaQuery } from "react-responsive";
import { DelayInput } from "react-delay-input";
// import dah from "../../assets/dah.svg";
// import dav from "../../assets/dav.svg";

import ModelOne from "../Shapes-models/ModelOne";
import ModelTwo from "../Shapes-models/ModelTwo";
import ModelThree from "../Shapes-models/ModelThree";
import ModelFour from "../Shapes-models/ModelFour";
import ModelFive from "../Shapes-models/ModelFive";
import ModelSix from "../Shapes-models/ModelSix";
import ModelSeven from "../Shapes-models/ModelSeven";
import ModelEight from "../Shapes-models/ModelEight";

import cx from "classnames";

function Stepfive(props) {


  const {
    shape,
    cmMM,

    inVal,
    setInVal,
    inVal2,
    setInVal2,
    inVal3,
    setInVal3,
    inVal4,
    setInVal4,
    inVal5,
    setInVal5,
    inVal6,
    setInVal6,
    inVal7,
    setInVal7,
    inVal8,
    setInVal8,
    inVal9,
    setInVal9,
    inVal10,
    setInVal10,
    activeColor,
    initialColor,
    stepDesc,
    handleNumber,
    maxLengthCheck,
    measureId,
    cart,
    unity2,
    unity3,
    result,
  } = useContext(SquareContext);
  const {
    box1c,
    box2c,
    box3c,
    box4c,
    box1r,
    box2r,
    box3r,
    box4r,
    box1l,
    box2l,
    box3l,
    box4l,
    box1t,
    box2t,
    box3t,
    box4t,
    box1is,
    box2is,
    box3is,
    box4is,
  } = useContext(ShapeContext);

  const boxes =
    box1c +
    box2c +
    box3c +
    box4c +
    box1r +
    box2r +
    box3r +
    box4r +
    box1l +
    box2l +
    box3l +
    box4l +
    box1t +
    box2t +
    box3t +
    box4t +
    box1is +
    box2is +
    box3is +
    box4is;

  const valTotal = parseInt(
    inVal +
      inVal2 +
      inVal3 +
      inVal4 +
      inVal5 +
      inVal6 +
      inVal7 +
      inVal8 +
      inVal9 +
      inVal10
  );

  const [btnColor5, setBtnColor5] = useState(initialColor);
  const [isMeasure, setIsMeasure] = useState(true);


console.log(result)
 
  useEffect(() => {
    if (
      shape.find((obj) => obj.id === 1) &&
      result > 0 &&
      inVal !== 0 &&
      inVal2 !== 0 &&
      boxes
    ) {
      setBtnColor5(activeColor);
    } else if (
      shape.find((obj) => obj.id === 2) &&
      result > 0 &&
      inVal !== 0 &&
      inVal2 !== 0 &&
      inVal3 !== 0 &&
      inVal4 !== 0 &&
      boxes
    ) {
      setBtnColor5(activeColor);
    } else if (
      shape.find((obj) => obj.id === 3) &&
      result > 0 &&
      inVal !== 0 &&
      inVal2 !== 0 &&
      inVal3 !== 0 &&
      inVal4 !== 0 &&
      inVal5 !== 0 &&
      inVal6 !== 0 &&
      boxes
    ) {
      setBtnColor5(activeColor);
    } else if (
      shape.find((obj) => obj.id === 4) &&
      result > 0 &&
      inVal !== 0 &&
      inVal2 !== 0 &&
      inVal3 !== 0 &&
      inVal4 !== 0 &&
      inVal5 !== 0 &&
      inVal6 !== 0 &&
      inVal7 !== 0 &&
      inVal8 !== 0 &&
      boxes
    ) {
      setBtnColor5(activeColor);
    } else if (
      shape.find((obj) => obj.id === 5) &&
      result > 0 &&
      inVal !== 0 &&
      inVal2 !== 0 &&
      inVal3 !== 0 &&
      inVal4 !== 0 &&
      inVal7 !== 0 &&
      inVal8 !== 0 &&
      boxes
    ) {
      setBtnColor5(activeColor);
    } else if (
      shape.find((obj) => obj.id === 6) &&
      result > 0 &&
      inVal !== 0 &&
      inVal2 !== 0 &&
      inVal3 !== 0 &&
      inVal4 !== 0 &&
      inVal5 !== 0 &&
      inVal6 !== 0 &&
      inVal7 !== 0 &&
      inVal8 !== 0 &&
      boxes
    ) {
      setBtnColor5(activeColor);
    } else if (
      shape.find((obj) => obj.id === 7) &&
      result > 0 &&
      inVal !== 0 &&
      inVal2 !== 0 &&
      inVal3 !== 0 &&
      inVal4 !== 0 &&
      inVal5 !== 0 &&
      inVal6 !== 0 &&
      inVal7 !== 0 &&
      inVal8 !== 0 &&
      inVal9 !== 0 &&
      inVal10 !== 0 &&
      boxes
    ) {
      setBtnColor5(activeColor);
    } else if (
      shape.find((obj) => obj.id === 8) &&
      result > 0 &&
      inVal !== 0 &&
      inVal2 !== 0 &&
      inVal7 !== 0 &&
      inVal8 !== 0 &&
      boxes
    ) {
      setBtnColor5(activeColor);
    } else {
      setBtnColor5(initialColor);
    }
  }, [valTotal, boxes, activeColor, initialColor, result]);

  useEffect(() => {
    if (cart.length === 0) {
      props.jump(1);
    }
  }, [cart]);

  useEffect(() => {
    if (unity2 === 0 && cart[1] !== undefined) {
      props.jump(3);
    }
  }, [cart, unity2]);

  useEffect(() => {
    if (unity3 === 0 && cart[2] !== undefined) {
      props.jump(3);
    }
  }, [cart, unity3]);

  const handleNext = () => {
    if (btnColor5 === activeColor && result > 0) {
     
      props.next();
    }
  };

  useEffect(() => {
    if(result < 0 ) {
      setIsMeasure(false)
    } else if (result > 0) {
      setIsMeasure(true)
    }
  }, [result])

 console.log(isMeasure)

  const handleMeasureErase = () => {
    setInVal(0);
    setInVal2(0);
    setInVal3(0);
    setInVal4(0);
    setInVal5(0);
    setInVal6(0);
    setInVal7(0);
    setInVal8(0);
    setInVal9(0);
    setInVal10(0);
  };

  const isMobile = useMediaQuery({ query: "(min-width: 600px)" });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="stepFiver">
    
        {stepDesc[4] && (
        <div>
      
          <div className="head">
            <p className="head-red">STEP 5</p>
            <p className="head-line">I</p>
            <p  dangerouslySetInnerHTML={{ __html: stepDesc[4].title }}></p>
          </div>
        </div>
      )}
        <div className="stone">
          <Squares
            first={() => {
              if (props.order === 5) {
                props.jump(1);
              } else {
                props.jump(5);
              }
            }}
            second={() => {
              if (props.order === 5) {
                props.jump(1);
              } else {
                props.jump(5);
              }
            }}
            third={() => {
              if (props.order === 5) {
                props.jump(1);
              } else {
                props.jump(5);
              }
            }}
          />
          {stepDesc[4] !== undefined && (
            <div className="text-middle"
            dangerouslySetInnerHTML={{ __html: stepDesc[4].description }}
            >
              {/* <Text
                desc={stepDesc[4] !== undefined && stepDesc[4].description}
              /> */}
            </div>
          )}

          
           <div
              className={cx(
                "buttons",
                shape.find((obj) => obj.id === 1) ? "active" : ""
              )}
            >
              <button
                className="btn-prev"
                onClick={() => {
                  props.prev();
                  handleMeasureErase();
                }}
                style={{ background: "#ff262d" }}
              >
                BACK STEP
              </button>
              <button
                className="btn-next"
                onClick={handleNext}
                style={{ background: btnColor5 }}
              >
                {isMeasure ? "NEXT STEP" : "WRONG MEASUREMENTS"}
              </button>
            </div>
        </div>
        <div className="shapes">
          <Elements  eleclass="elements"/>
          <div className="shapes-form-container">
            {/* --------------------------------------------------Model One --------------------------------------------- */}
            {shape.find((obj) => obj.id === 1) && (
              <div className="dim-shape">
                <ModelOne />
                {!isMobile && (
                  <div className="model-input-600">
                    {/* <div className="model-img-600">
                    <img className="vertical-model" src={dav} alt="" />
                      <img className="horizontal-model" src={dah} alt="" />
                    </div> */}
                    <div className="model-606">
                      <span className="span-mea">1:</span>
                      <DelayInput
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        className="ipt1"
                        type="number"
                        value={inVal}
                        onChange={(e) => handleNumber(e, setInVal)}
                        id="qtv"
                        name="qt"
                        min="0"
                        autoComplete="off"
                      ></DelayInput>

                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        value={inVal2}
                        onChange={(e) => handleNumber(e, setInVal2)}
                        id="qth"
                        name="qt"
                        min="0"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                      ></DelayInput>
                      {cmMM}
                    </div>
                  </div>
                )}
              </div>
            )}
            {/* --------------------------------------------------Model Two --------------------------------------------- */}
            {shape.find((obj) => obj.id === 2) && (
              <div className="dim-shape">
                <ModelTwo />
                {!isMobile && (
                  <div className="model-input-600">
                    <div className="model-606">
                      <span className="span-mea">1:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        value={inVal}
                        onChange={(e) => handleNumber(e, setInVal)}
                        id="qtv"
                        name="qt"
                        min="0"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        value={inVal2}
                        onChange={(e) => handleNumber(e, setInVal2)}
                        id="qth"
                        name="qt"
                        min="0"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                      ></DelayInput>
                      {cmMM}
                    </div>
                    <div className="model-606">
                      <span className="span-mea">2:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        value={inVal4}
                        onChange={(e) => handleNumber(e, setInVal4)}
                        id="qtv"
                        name="qt"
                        min="0"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        value={inVal3}
                        onChange={(e) => handleNumber(e, setInVal3)}
                        id="qth"
                        name="qt"
                        min="0"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                      ></DelayInput>
                      {cmMM}
                    </div>
                  </div>
                )}
              </div>
            )}
            {/* --------------------------------------------------Model Three --------------------------------------------- */}
            {shape.find((obj) => obj.id === 3) && (
              <div className="dim-shape">
                <ModelThree />
                {!isMobile && (
                  <div className="model-input-600">
                    <div className="model-606">
                      <span className="span-mea">1:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        value={inVal}
                        onChange={(e) => handleNumber(e, setInVal)}
                        id="qtv"
                        name="qt"
                        min="0"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        value={inVal2}
                        onChange={(e) => handleNumber(e, setInVal2)}
                        id="qth"
                        name="qt"
                        min="0"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                      ></DelayInput>
                      {cmMM}
                    </div>
                    <div className="model-606">
                      <span className="span-mea">2:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        value={inVal4}
                        onChange={(e) => handleNumber(e, setInVal4)}
                        id="qtv"
                        name="qt"
                        min="0"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        value={inVal3}
                        onChange={(e) => handleNumber(e, setInVal3)}
                        id="qth"
                        name="qt"
                        min="0"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                      ></DelayInput>
                      {cmMM}
                    </div>
                    <div className="model-606">
                      <span className="span-mea">3:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        value={inVal6}
                        onChange={(e) => handleNumber(e, setInVal6)}
                        id="qtv"
                        name="qt"
                        min="0"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        value={inVal5}
                        onChange={(e) => handleNumber(e, setInVal5)}
                        id="qth"
                        name="qt"
                        min="0"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                      ></DelayInput>
                      {cmMM}
                    </div>
                  </div>
                )}
              </div>
            )}
            {/* --------------------------------------------------Model Four --------------------------------------------- */}
            {shape.find((obj) => obj.id === 4) && (
              <div className="dim-shape">
                <ModelFour />
                {!isMobile && (
                  <div className="model-input-600">
                    <div className="model-606">
                      <span className="span-mea">1:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        value={inVal}
                        onChange={(e) => handleNumber(e, setInVal)}
                        id="qtv"
                        name="qt"
                        min="0"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        value={inVal2}
                        onChange={(e) => handleNumber(e, setInVal2)}
                        id="qth"
                        name="qt"
                        min="0"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                      ></DelayInput>
                      {cmMM}
                    </div>
                    <div className="model-606">
                      <span className="span-mea">2:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        value={inVal4}
                        onChange={(e) => handleNumber(e, setInVal4)}
                        id="qtv"
                        name="qt"
                        min="0"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        value={inVal3}
                        onChange={(e) => handleNumber(e, setInVal3)}
                        id="qth"
                        name="qt"
                        min="0"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                      ></DelayInput>
                      {cmMM}
                    </div>
                    <div className="model-606">
                      <span className="span-mea">3:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        value={inVal6}
                        onChange={(e) => handleNumber(e, setInVal6)}
                        id="qtv"
                        name="qt"
                        min="0"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        value={inVal5}
                        onChange={(e) => handleNumber(e, setInVal5)}
                        id="qth"
                        name="qt"
                        min="0"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                      ></DelayInput>
                      {cmMM}
                    </div>
                    <div className="model-606">
                      <span className="span-mea">4:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        value={inVal7}
                        onChange={(e) => handleNumber(e, setInVal7)}
                        id="qtv"
                        name="qt"
                        min="0"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        value={inVal8}
                        onChange={(e) => handleNumber(e, setInVal8)}
                        id="qth"
                        name="qt"
                        min="0"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                      ></DelayInput>
                      {cmMM}
                    </div>
                  </div>
                )}
              </div>
            )}
            {/* --------------------------------------------------Model five --------------------------------------------- */}
            {shape.find((obj) => obj.id === 5) && (
              <div className="dim-shape">
                <ModelFive />
                {!isMobile && (
                  <div className="model-input-600">
                    <div className="model-606">
                      <span className="span-mea">1:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal}
                        onChange={(e) => handleNumber(e, setInVal)}
                        id="qtv"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal2}
                        onChange={(e) => handleNumber(e, setInVal2)}
                        id="qth"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      {cmMM}
                    </div>
                    <div className="model-606">
                      <span className="span-mea">2:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal4}
                        onChange={(e) => handleNumber(e, setInVal4)}
                        id="qtv"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal3}
                        onChange={(e) => handleNumber(e, setInVal3)}
                        id="qth"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      {cmMM}
                    </div>
                    <div className="model-606">
                      <span className="span-mea">4:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal7}
                        onChange={(e) => handleNumber(e, setInVal7)}
                        id="qtv"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal8}
                        onChange={(e) => handleNumber(e, setInVal8)}
                        id="qth"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      {cmMM}
                    </div>
                  </div>
                )}
              </div>
            )}
            {/* --------------------------------------------------Model six --------------------------------------------- */}
            {shape.find((obj) => obj.id === 6) && (
              <div className="dim-shape">
                <ModelSix />
                {!isMobile && (
                  <div className="model-input-600">
                    <div className="model-606">
                      <span className="span-mea">1:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal}
                        onChange={(e) => handleNumber(e, setInVal)}
                        id="qtv"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal2}
                        onChange={(e) => handleNumber(e, setInVal2)}
                        id="qth"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      {cmMM}
                    </div>
                    <div className="model-606">
                      <span className="span-mea">2:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal4}
                        onChange={(e) => handleNumber(e, setInVal4)}
                        id="qtv"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal3}
                        onChange={(e) => handleNumber(e, setInVal3)}
                        id="qth"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      {cmMM}
                    </div>
                    <div className="model-606">
                      <span className="span-mea">3:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal6}
                        onChange={(e) => handleNumber(e, setInVal6)}
                        id="qtv"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal5}
                        onChange={(e) => handleNumber(e, setInVal5)}
                        id="qth"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      {cmMM}
                    </div>
                    <div className="model-606">
                      <span className="span-mea">4:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal7}
                        onChange={(e) => handleNumber(e, setInVal7)}
                        id="qtv"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal8}
                        onChange={(e) => handleNumber(e, setInVal8)}
                        id="qth"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      {cmMM}
                    </div>
                  </div>
                )}
              </div>
            )}
            {/* --------------------------------------------------Model seven --------------------------------------------- */}
            {shape.find((obj) => obj.id === 7) && (
              <div className="dim-shape">
                <ModelSeven />
                {!isMobile && (
                  <div className="model-input-600">
                    <div className="model-606">
                      <span className="span-mea">1:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal}
                        onChange={(e) => handleNumber(e, setInVal)}
                        id="qtv"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal2}
                        onChange={(e) => handleNumber(e, setInVal2)}
                        id="qth"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      {cmMM}
                    </div>
                    <div className="model-606">
                      <span className="span-mea">2:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal4}
                        onChange={(e) => handleNumber(e, setInVal4)}
                        id="qtv"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal3}
                        onChange={(e) => handleNumber(e, setInVal3)}
                        id="qth"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      {cmMM}
                    </div>
                    <div className="model-606">
                      <span className="span-mea">3:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal6}
                        onChange={(e) => handleNumber(e, setInVal6)}
                        id="qtv"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal5}
                        onChange={(e) => handleNumber(e, setInVal5)}
                        id="qth"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      {cmMM}
                    </div>
                    <div className="model-606">
                      <span className="span-mea">4:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal7}
                        onChange={(e) => handleNumber(e, setInVal7)}
                        id="qtv"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal8}
                        onChange={(e) => handleNumber(e, setInVal8)}
                        id="qth"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      {cmMM}
                    </div>
                    <div className="model-606">
                      <span className="span-mea">5:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal9}
                        onChange={(e) => handleNumber(e, setInVal9)}
                        id="qtv"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal10}
                        onChange={(e) => handleNumber(e, setInVal10)}
                        id="qth"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      {cmMM}
                    </div>
                  </div>
                )}
              </div>
            )}
            {/* ----------------------------------------Model--Eight--------------------------------------------- */}
            {shape.find((obj) => obj.id === 8) && (
              <div className="dim-shape">
                <ModelEight />
                {!isMobile && (
                  <div className="model-input-600">
                    <div className="model-606">
                      <span className="span-mea">1:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal}
                        onChange={(e) => handleNumber(e, setInVal)}
                        id="qtv"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal2}
                        onChange={(e) => handleNumber(e, setInVal2)}
                        id="qth"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      {cmMM}
                    </div>
                    <div className="model-606">
                      <span className="span-mea">2:</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal7}
                        onChange={(e) => handleNumber(e, setInVal7)}
                        id="qtv"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      <span className="span-mid">x</span>
                      <DelayInput
                        className="ipt1"
                        type="number"
                        autoComplete="off"
                        delayTimeout={600}
                        maxLength={
                          measureId.id === 1 || measureId.id === 3 ? 4 : 6
                        }
                        // onInput={maxLengthCheck}
                        value={inVal8}
                        onChange={(e) => handleNumber(e, setInVal8)}
                        id="qth"
                        name="qt"
                        min="0"
                      ></DelayInput>
                      {cmMM}
                    </div>
                  </div>
                )}
              </div>
            )}
            <div
              className={cx(
                "buttons btn-dwn5",
                shape.find((obj) => obj.id === 1) ? "active" : ""
              )}
            >
              <button
                className="btn-prev"
                onClick={() => {
                  props.prev();
                  handleMeasureErase();
                }}
                style={{ background: "#ff262d" }}
              >
                BACK STEP
              </button>
              <button
                className="btn-next"
                onClick={handleNext}
                style={{ background: btnColor5 }}
              >
                {isMeasure ? "NEXT STEP" : "WRONG MEASUREMENTS"}
              </button>
            </div>
          </div>
        </div>
       
      </div>
    </>
  );
}

export default Stepfive;
